import { THEMES } from '../data/product/product.data';

/** A text colour on a background colour, and the theme it came from. */
export interface ContrastPair {
  fg: string;
  bg: string;
  theme: string;
}

/**
 * A random Codigrate theme's editor text on its editor background (owner 2026-10-15): the pair a developer reads
 * all day, so the contrast checker opens on a real, readable pair, a different one each visit.
 */
export function randomThemeContrastPair(): ContrastPair {
  const themes = ( [] as any[] ).concat( ...THEMES.map( line => line.products ) )
    .filter( ( p: any ) => p.designTokens?.editorForeground && p.designTokens?.editorBackground );
  const pick = themes[ Math.floor( Math.random() * themes.length ) ];
  if ( !pick ) {
    return { fg: '#1A3746', bg: '#E4ECEF', theme: '' };
  }
  const hex = ( v: string ) => '#' + String( v ).replace( '#', '' ).slice( 0, 6 ).toUpperCase();
  return { fg: hex( pick.designTokens!.editorForeground! ), bg: hex( pick.designTokens!.editorBackground! ), theme: pick.name };
}
